var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"grid",class:{
  'grid--two-columns': _vm.twoColumns,
  'grid--three-columns': _vm.threeColumns,
}},_vm._l((_vm.items),function(item){return _c('li',{key:item.id,staticClass:"grid__item"},[_vm._t("item",null,null,item)],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }